module.exports = __webpack_public_path__ + "static/organising-workflow-folders-99bcd186d445449d7cb5e2ac242fd930.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/organising-workflow-folders.png
// module id = 2694
// module chunks = 157636680307020